import { Homepage } from "@/components/homepage";
import { SEO } from "@/components/seo";

const Index = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AffinityAim",
    "url": "https://www.affinityaim.com",
    "logo": "https://www.affinityaim.com/logo.png",
    "description": "Leading web development company specializing in custom websites, web apps, UI/UX design, and AI integration for growth-stage businesses.",
    "foundingDate": "2020",
    "email": "post@affinityaim.com",
    "sameAs": [
      "https://linkedin.com/company/affinityaim",
      "https://github.com/affinityaim",
      "https://twitter.com/affinityaim"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "AffinityAim",
    "url": "https://www.affinityaim.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.affinityaim.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <>
      <SEO
        title="AffinityAim - Web Development Company | Custom Software & UI UX Design"
        description="Top-rated web development company delivering high-performance websites, web apps, and AI solutions. Trusted by 100+ businesses. Get 47% avg conversion increase."
        canonical="https://www.affinityaim.com/"
        keywords="web development company, custom software development, UI UX design agency, web app development, AI integration services"
        schema={[organizationSchema, websiteSchema]}
      />
      <Homepage />
    </>
  );
};

export default Index;
